import React from "react";
import { Page, FormGroup, required, SubmitButton } from "components/common";
import { LocalForm, Control, actions } from "react-redux-form";
import { isEmail } from "validator";
import { Alert } from "reactstrap";
import { compose, withHandlers, withStateHandlers } from "recompose";
import { Trans } from "react-i18next";

const initialState = {
  name: "",
  email: "",
  description: "",
};


export const Support = ({ onSubmit, setDispatch, completed }) => (
  <div className="contact-us">
    <h4 className="card-title" id="contact-us">
      <div className="img-contact-us row mb-5" >
        <img src="images/landing/contact-us-hesaab.jpg" alt="" className="mx-auto" style={{width: "80%", height: "400px", objectFit: "fill"}}/>
      </div>
      <Trans>Contact Us</Trans>
    </h4>
    <p className="description">
      <Trans>Get in touch with us for any inquiries, support, or feedback about Hesaab. We're here to help!</Trans>
    </p>
    {completed ? (
      <Alert color="success">
        <Trans>
          Thank you, your support request has been received and a representative
          will contact you in due course.
        </Trans>
      </Alert>
    ) : (
      <LocalForm
        onSubmit={onSubmit}
        getDispatch={setDispatch}
        initialState={initialState}
        validators={{
          name: { required },
          email: { isEmail },
          description: { required },
        }}
      >
        <FormGroup label="Your name" model=".name">
          <Control.text model=".name" />
        </FormGroup>
        <FormGroup label="Your email address" model=".email">
          <Control.text model=".email" />
        </FormGroup>
        <FormGroup label="Please describe what you would like support with" model=".description" >
          <Control.textarea rows="5" model=".description" />
        </FormGroup>
        <div className="d-flex justify-content-end">
          <SubmitButton>Submit</SubmitButton>
        </div>
      </LocalForm>
    )}
  </div>
);

export const enhance = compose(
  withStateHandlers(
    {},
    {
      setCompleted: () => (completed) => ({ completed }),
      setDispatch: () => (dispatch) => ({ dispatch }),
    }
  ),
  withHandlers({
    onSubmit:
      ({ client, setCompleted, dispatch }) =>
        (item) => {
          return client
            .post("support", item)
            .then(() => setCompleted(true))
            .finally(() => dispatch(actions.setPending("local", false)));
        },
  })
);

export default enhance(Support);
